import service from '@/utils/request'

// 采购员 获取订单列表
export function orderList(param) {
    return service.request({
        method: 'POST',
        url: '/app/order/orderList',
        data: param
    })
}

// 采购员 获取订单明细
export function orderMxList(param) {
    return service.request({
        method: 'POST',
        url: '/app/orderMx/orderMxList',
        data: param
    })
}

// 采购员 获取订单详情
export function orderById(param) {
    return service.request({
        method: 'POST',
        url: '/app/order/orderById',
        data: param
    })
}

// 采购员 发布订单
export function publishFinalOrder(param) {
    return service.request({
        method: 'POST',
        url: '/app/order/publishFinalOrder',
        data: param
    })
}

// 供应商更新订单
export function gysUpdateList(param) {
    return service.request({
        method: 'POST',
        url: '/app/orderMx/updateList',
        data: param
    })
}

// 供应商确认订单
export function confirmFinalOrder(param) {
    return service.request({
        method: 'POST',
        url: '/app/order/confirmFinalOrder',
        data: param
    })
}

// 供应商获取统计
export function queryOrderStatic(param) {
    return service.request({
        method: 'POST',
        url: '/app/order/queryOrderStatic',
        data: param
    })
}



















